import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import authProvider from "../providers/authProvider";

const CountdownTimer = ({ initialTime = 1200, active = false, onRefresh = null, onSave = null, isAdmin = false }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(active);
  const [admin, setAdmin] = useState(isAdmin);

  useEffect(() => {
    setTimeLeft(initialTime);
    setIsRunning(active);
    setAdmin(isAdmin);
  }, [initialTime, active, isAdmin]);

  useEffect(() => {
    let interval;
    if (isRunning) {
        interval = setInterval(() => {
            setTimeLeft(prevTime => prevTime - 1);
        }, 1000);
    }

    return () => clearInterval(interval);
   }, [isRunning]);

    // Separare la chiamata API in un altro useEffect per evitare duplicati
    useEffect(() => {
        if (timeLeft > 0 && timeLeft % 10 === 0 && !admin && isRunning) {
            authProvider.saveDemoSecondsRemaining(timeLeft).then(() => {
              if(onSave) {
                onSave();
              }
            });
        }
        onRefresh(timeLeft)
    }, [timeLeft, isRunning, admin]);

  const formatTime = (seconds) => {
    if (seconds <= 0) {
      return "0:00";
    }
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <Box p={3}>
      <Typography variant="h5" color="white">
        {formatTime(timeLeft)}
      </Typography>
    </Box>
  );
};

export default CountdownTimer;